import { ErrorMessage } from './error-message';
import { OrderLine } from './order-line';
import { OrderLineGroup } from './order-line-group';
import { PortalInformation } from './portal-information';
import {
  LineStatus,
  MediaType,
  OrderType,
  SourceSystem,
  ShipmentResetType
} from './enums';
import { SgcOrderFulfillmentDetails } from './sgc-order-fulfillment-details';
import { TrackingCodeInfo } from './tracking-code-info';

export class OrderShipment {
  arcCustomerId?: number;
  orderNumber: number;
  customerNumber: number;
  shipmentNumber: number;
  shipDate: Date;
  needDate: Date;
  orderEntryDate: Date;
  orderType: OrderType;
  status: LineStatus;
  allLinesAreCancelled: boolean;
  hasError: boolean;
  customerName: string;
  drmType?: string;
  stream: string;
  digitalProfile: number;
  digitalProfileDescription: string;
  accountExecutive: string;
  entryUserName: string;
  errors: ErrorMessage[];
  marketOrgType?: string;
  marketSalesDivision?: string;
  manufacturingProfileId?: number;
  manufacturingProfileDescription?: string;
  mediaType: MediaType;
  lines: OrderLine[];
  lineGroups?: OrderLineGroup[];
  digitalSequenceNumber: number;
  sourceSystem: SourceSystem;
  burnStation: string; // ADEBS uses this
  sgcFulfillmentDetails: SgcOrderFulfillmentDetails;
  trackingCodeInfo: TrackingCodeInfo;
  shippingAddress: string;
  shippingCity: string;
  shippingState: string;
  shippingZip: string;
  shippingCountry: string;
  portalId?: string;
  titles?: string[];
  uploadShipmentToNetworkShare?: boolean; // only hard drives currently
  isOrderProcessing?: boolean;
  portalInformation?: PortalInformation[];
  cinelinkBoxIds?: number[];
  isScheduleCompleted: boolean;
  isScheduleRequired: boolean;
  isScheduleCreatedInDatabase: boolean; // does a schedule exist in the database (translates to making it required)
  comments?: string[];
  shipmentStatus: string;
  orderSourceSystem: number;
  allowedResets?: ShipmentResetType[];

  constructor() {
    this.orderNumber = null;
    this.customerNumber = null;
    this.shipmentNumber = 1;
    this.shipDate = new Date();
    this.needDate = new Date();
    this.orderEntryDate = new Date();
    this.orderType = OrderType.Unknown;
    this.status = LineStatus.Pending;
    this.allLinesAreCancelled = false;
    this.hasError = true; // this will help show on orders listing by default
    this.customerName = '';
    this.drmType = '';
    this.stream = '';
    this.digitalProfile = null;
    this.digitalProfileDescription = '';
    this.accountExecutive = '';
    this.entryUserName = '';
    this.errors = [];
    this.manufacturingProfileId = null;
    this.marketOrgType = '';
    this.marketSalesDivision = '';
    this.mediaType = MediaType.Unknown;
    this.lines = [];
    this.lineGroups = [];
    this.digitalSequenceNumber = null;
    this.sourceSystem = SourceSystem.Sgc;
    this.burnStation = '';
    this.trackingCodeInfo = null;
    this.shippingAddress = '';
    this.shippingCity = '';
    this.shippingState = '';
    this.shippingZip = '';
    this.shippingCountry = '';
    this.portalId = null;
    this.titles = [];
    this.uploadShipmentToNetworkShare = false; // only hard drives currently need this
    this.isOrderProcessing = false;
    this.portalInformation = null;
    this.isScheduleCompleted = false;
    this.isScheduleRequired = false;
    this.sgcFulfillmentDetails = null;
    this.manufacturingProfileDescription = '';
    this.cinelinkBoxIds = null;
    this.comments = [];
    this.shipmentStatus = '';
    this.orderSourceSystem = null;
  }
}
